import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// Auth API
export const authAPI = {
  login: async (email, password) => {
    return api.post('/auth/login', { email, password });
  },
  getMe: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/admin/change-password', data),
};

// Public Content API
export const contentAPI = {
  getStats: () => api.get('/content/stats'),
  getServices: (category = null) => api.get('/content/services', { params: { category } }),
  getServiceBySlug: (slug) => api.get(`/content/services/${slug}`),
  getPartners: () => api.get('/content/partners'),
  getIndustries: () => api.get('/content/industries'),
  getWorkingModel: () => api.get('/content/working-model'),
  getLegalContent: () => api.get('/content/legal'),
  getLLPDetails: () => api.get('/content/llp-details'),
  getSEO: (page) => api.get(`/content/seo/${page}`),
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact/submit', data),
};

// Admin API
export const adminAPI = {
  // Stats
  createStat: (data) => api.post('/admin/stats', data),
  updateStat: (key, data) => api.put(`/admin/stats/${key}`, data),
  deleteStat: (key) => api.delete(`/admin/stats/${key}`),
  
  // Services
  createService: (data) => api.post('/admin/services', data),
  updateService: (slug, data) => api.put(`/admin/services/${slug}`, data),
  deleteService: (slug) => api.delete(`/admin/services/${slug}`),
  
  // Partners
  createPartner: (data) => api.post('/admin/partners', data),
  updatePartner: (name, data) => api.put(`/admin/partners/${name}`, data),
  deletePartner: (name) => api.delete(`/admin/partners/${name}`),
  
  // Industries
  createIndustry: (data) => api.post('/admin/industries', data),
  updateIndustry: (slug, data) => api.put(`/admin/industries/${slug}`, data),
  deleteIndustry: (slug) => api.delete(`/admin/industries/${slug}`),
  
  // Working Model
  createWorkingStep: (data) => api.post('/admin/working-model', data),
  deleteWorkingStep: (stepNumber) => api.delete(`/admin/working-model/${stepNumber}`),
  
  // Legal Content
  updateLegalContent: (data) => api.put('/admin/legal', data),
  
  // LLP Details
  getLLPDetails: () => api.get('/content/llp-details'),
  updateLLPDetails: (data) => api.put('/admin/llp-details', data),
  
  // Leads
  getLeads: () => api.get('/admin/leads'),
  markLeadContacted: (email) => api.put(`/admin/leads/${email}/contacted`),
  
  // SEO
  updateSEO: (data) => api.put('/admin/seo', data),
  
  // Dashboard
  getDashboardStats: () => api.get('/admin/dashboard/stats'),
};

// Download API
export const downloadAPI = {
  corporateProfile: () => `${API}/download/corporate-profile`,
};

// Theme API
export const themeAPI = {
  getActive: () => api.get('/theme'),
  getAll: () => api.get('/admin/theme'),
  create: (data) => api.post('/admin/theme', data),
  update: (presetName, data) => api.put(`/admin/theme/${presetName}`, data),
  activate: (presetName) => api.put(`/admin/theme/activate?preset_name=${encodeURIComponent(presetName)}`),
  delete: (presetName) => api.delete(`/admin/theme/${presetName}`),
};
